<div
  class="relative w-full min-h-screen flex items-center justify-center overflow-hidden px-4 sm:px-6 lg:px-8 py-12"
>
  <div class="absolute inset-0 z-0">
    <img
      src="auth-bg.webp"
      class="w-full h-full object-cover"
      alt="Casino Background"
    />
    <div class="absolute inset-0 bg-black/60"></div>
  </div>

  <div
    class="pointer-events-none absolute bottom-0 left-0 z-20 w-[80px] sm:w-[120px] md:w-[160px] lg:w-[200px] translate-y-[10%] sm:translate-y-[5%]"
  >
    <img loading="lazy"
      src="money-bag l.png"
      class="w-full h-auto object-contain"
      alt="Money Bag Left"
    />
  </div>

  <div
    class="pointer-events-none absolute bottom-0 right-0 z-20 w-[80px] sm:w-[120px] md:w-[160px] lg:w-[200px] translate-y-[10%] sm:translate-y-[5%]"
  >
    <img loading="lazy"
      src="money-bag r.png"
      class="w-full h-auto object-contain"
      alt="Money Bag Right"
    />
  </div>

  <div
    class="relative z-10 flex flex-col items-center justify-center text-center w-full max-w-[95%] sm:max-w-[600px] lg:max-w-[700px] px-4 sm:px-6 md:px-8 py-8 sm:py-10 md:py-12 rounded-2xl sm:rounded-3xl md:rounded-4xl backdrop-blur-[4px]"
    style="
      background: radial-gradient(
        109.95% 50.69% at 23.83% 47.4%,
        rgba(87, 129, 166, 0.8) 0%,
        rgba(102, 144, 173, 0.32) 67.78%
      );
      box-shadow:
        inset 0px 0px 0.5px 0px #ffffff80,
        inset 0px 0px 8px 0px #aaaaaa80,
        0px 4px 20px rgba(0, 0, 0, 0.25);
    "
  >
    <h1
      class="font-bold text-[#A6B1C2] text-[24px] sm:text-[32px] md:text-[44px] lg:text-[52px]"
    >
      Immersive <br class="sm:hidden lg:block" />
      <span class="text-white">Adventures</span> Await
    </h1>

    <p
      class="text-white/70 mt-4 text-[12px] sm:text-[14px] md:text-[16px] lg:text-[17px] max-w-[600px] leading-relaxed font-medium"
    >
      Step into a world where every play is a journey. Explore breathtaking
      realms, uncover hidden treasures, and challenge your luck in the ultimate
      gaming quest designed for true thrill-seekers.
    </p>

    <button
      (click)="redirectToSignUp()"
      class="mt-6 md:mt-8 flex items-center justify-center w-[160px] sm:w-[200px] md:w-[240px] h-[44px] sm:h-[50px] md:h-[54px] bg-[#1C5F72] text-white font-bold text-[13px] sm:text-[15px] md:text-[16px] backdrop-blur-[12px] shadow-[0px_4px_15px_rgba(0,0,0,0.3)] hover:brightness-110 hover:scale-105 active:scale-95 transition-all duration-300 uppercase tracking-wider"
    >
      Join Now!
    </button>
  </div>
</div>
